<template>
  <v-app>
    <v-main>
      <DeploymentComponent/>
    </v-main>
  </v-app>
</template>

<script>
import DeploymentComponent from './components/DeploymentComponent';

export default {
  name: 'App',

  components: {
    DeploymentComponent,
  },

  data: () => ({
    //
  }),
};
</script>
